export class FileData {
	
	filename: string;
	blob: Blob;
	content: String;

	constructor(filename: string, blob: Blob, content?: string){
		this.filename=filename;
		this.blob=blob;
		this.content = content!;
	}
}
